import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface FiscalYearPeriods {
  periodId: number | null;
  startDate: string;
  endDate: string;
}
interface NonCalendarYearRequest {
  companyId: number;
  fiscalYear: number;
  periods: FiscalYearPeriods[];
}

const useUpdateCalendarPeriodApi = () => {
  const call = useCallback(async (data?: NonCalendarYearRequest) => {
    try {
      const res = await axiosInstance.put<NonCalendarYearRequest>(api.createNoNCalendarYear, data);

      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { execute } = useAsync(call, false);

  return {
    updateNonCalendarPeriod: execute,
  };
};

export default useUpdateCalendarPeriodApi;
